module.exports = __webpack_public_path__ + "media/logos/wsj-logo-white-f11a9f16.png";